import React from 'react';
import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import RowAccount from 'features/accounts/components/RowAccount';
import RowEmmaInvestAccount from 'features/accounts/components/RowEmmaInvestAccount';
import RowPotAccount from 'features/accounts/components/RowPotAccount';
import { selectUserId } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { isWeb } from '../../../constants';
const AccountItem = ({ account, onPress, plusIcon = false, minusIcon = false, disabled = false, hideSpaceUserAvatar = false, }) => {
    const myId = useAppSelector(selectUserId);
    if ('productId' in account) {
        return (<RowPotAccount onCard style={styles.row} data={account} onPress={onPress} disabled={disabled || account.userId !== myId} plusIcon={plusIcon} minusIcon={minusIcon} hideSpaceUserAvatar={hideSpaceUserAvatar}/>);
    }
    if ('isEmmaInvestmentAccount' in account) {
        return (<RowEmmaInvestAccount onCard style={styles.row} data={account} onPress={onPress} disabled={disabled || account.userId !== myId} plusIcon={plusIcon} minusIcon={minusIcon} hideSpaceUserAvatar={hideSpaceUserAvatar}/>);
    }
    return (<RowAccount onCard style={styles.row} data={account} isSelectingAccounts onPress={onPress} plusIcon={plusIcon} minusIcon={minusIcon} disabled={disabled || account.userId !== myId} hideSpaceUserAvatar={hideSpaceUserAvatar}/>);
};
const styles = StyleSheet.create({
    row: {
        paddingHorizontal: rem(16),
        ...(isWeb && {
            paddingHorizontal: rem(8),
        }),
    },
});
export default AccountItem;
